import React, { useState } from 'react';

export default function Step2ADILicence({ formData, files, errors, updateField, updateFile, clearError, setError }) {
  const h = (e) => { updateField(e.target.name, e.target.value); clearError(e.target.name); };
  const hf = (e) => { updateFile(e.target.name, e.target.files[0]); clearError(e.target.name); };
  const handlePRN = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
    updateField('prn', val);
    clearError('prn');
  };

  // Badge expiry — DD/MM/YYYY text inputs for mobile compatibility
  const initExpiry = () => {
    const v = formData.badge_expiry || '';
    const [y, m, d] = v.split('-');
    return { day: d || '', month: m || '', year: y || '' };
  };
  const [expiryParts, setExpiryParts] = useState(initExpiry);

  const handleExpiry = (part, rawVal) => {
    const maxLen = part === 'year' ? 4 : 2;
    const val = rawVal.replace(/\D/g, '').slice(0, maxLen);
    const next = { ...expiryParts, [part]: val };
    setExpiryParts(next);
    if (next.day && next.month && next.year.length === 4) {
      updateField('badge_expiry', `${next.year}-${next.month.padStart(2, '0')}-${next.day.padStart(2, '0')}`);
    } else {
      updateField('badge_expiry', '');
    }
    clearError('badge_expiry');
  };

  const handleExpiryBlur = () => {
    const val = formData.badge_expiry;
    if (!val) return;
    const expiry = new Date(val);
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const max = new Date(today); max.setFullYear(max.getFullYear() + 4);
    if (expiry < today)
      setError('badge_expiry', 'Your ADI badge must not be expired — enter the expiry date shown on your badge');
    else if (expiry > max)
      setError('badge_expiry', 'Check date — ADI badges are valid for up to 4 years from issue');
    else
      clearError('badge_expiry');
  };

  return (
    <div className="adi-step-content">
      <div className="adi-step-header">
        <span className="adi-step-num-badge">2</span>
        <div>
          <h2 className="adi-step-title">ADI Licence &amp; DVSA Registration</h2>
          <p className="adi-step-desc">Your professional driving instructor credentials</p>
        </div>
      </div>

      <div className="adi-field-grid">

        <div className="adi-field">
          <label>PRN – Personal Reference Number *</label>
          <input name="prn" value={formData.prn || ''} onChange={handlePRN}
            placeholder="e.g. 123456"
            inputMode="numeric"
            maxLength={6}
            className={errors.prn ? 'err' : ''} />
          {errors.prn
            ? <span className="adi-err">{errors.prn}</span>
            : <p className="adi-field-note">Exactly 6 digits — found on the front of your green ADI badge</p>
          }
        </div>

        <div className="adi-field adi-field--full">
          <div className="adi-info-banner">
            <span>ℹ️</span>
            <span>Fast Track Driving School accepts <strong>fully qualified ADIs (Green Badge holders) only</strong>. Trainee (pink badge) applications cannot be accepted at this time.</span>
          </div>
        </div>

        <div className="adi-field adi-field--full">
          <label>Badge Expiry Date * <em style={{ fontWeight: 400, fontSize: '0.8rem' }}>(DD / MM / YYYY)</em></label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1.8fr', gap: '0.5rem' }}>
            <input
              type="text"
              inputMode="numeric"
              placeholder="DD"
              value={expiryParts.day}
              onChange={e => handleExpiry('day', e.target.value)}
              onBlur={handleExpiryBlur}
              className={errors.badge_expiry ? 'err' : ''}
              maxLength={2}
            />
            <input
              type="text"
              inputMode="numeric"
              placeholder="MM"
              value={expiryParts.month}
              onChange={e => handleExpiry('month', e.target.value)}
              onBlur={handleExpiryBlur}
              className={errors.badge_expiry ? 'err' : ''}
              maxLength={2}
            />
            <input
              type="text"
              inputMode="numeric"
              placeholder="YYYY"
              value={expiryParts.year}
              onChange={e => handleExpiry('year', e.target.value)}
              onBlur={handleExpiryBlur}
              className={errors.badge_expiry ? 'err' : ''}
              maxLength={4}
            />
          </div>
          <p className="adi-field-note">Must be today or future · found on the front of your green badge · e.g. 31 05 2027</p>
          {errors.badge_expiry && <span className="adi-err">{errors.badge_expiry}</span>}
        </div>

        <div className="adi-field adi-field--upload">
          <label>Green Badge – Front Photo *</label>
          <p className="adi-upload-hint">Upload a clear photo or scan of the front of your green ADI badge</p>
          <div className={`adi-upload-box${errors.green_badge_front ? ' adi-upload-box--err' : ''}`}>
            <input type="file" name="green_badge_front" onChange={hf} accept="image/*,.pdf" />
            <div className="adi-upload-label">
              {files.green_badge_front ? (
                <span className="adi-upload-selected">✓ {files.green_badge_front.name}</span>
              ) : (
                <><span className="adi-upload-icon">📷</span> Click to upload or drag here</>
              )}
            </div>
          </div>
          {errors.green_badge_front && <span className="adi-err">{errors.green_badge_front}</span>}
        </div>

        <div className="adi-field adi-field--upload">
          <label>Green Badge – Back Photo *</label>
          <p className="adi-upload-hint">Upload a clear photo or scan of the back of your green ADI badge</p>
          <div className={`adi-upload-box${errors.green_badge_back ? ' adi-upload-box--err' : ''}`}>
            <input type="file" name="green_badge_back" onChange={hf} accept="image/*,.pdf" />
            <div className="adi-upload-label">
              {files.green_badge_back ? (
                <span className="adi-upload-selected">✓ {files.green_badge_back.name}</span>
              ) : (
                <><span className="adi-upload-icon">📷</span> Click to upload or drag here</>
              )}
            </div>
          </div>
          {errors.green_badge_back && <span className="adi-err">{errors.green_badge_back}</span>}
        </div>

      </div>
    </div>
  );
}
